import { render, staticRenderFns } from "./TeamSelectorCard.vue?vue&type=template&id=863f5610&"
import script from "./TeamSelectorCard.vue?vue&type=script&lang=js&"
export * from "./TeamSelectorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports